import { render } from "./MailingAddComponent.vue?vue&type=template&id=1ddac058&scoped=true"
import script from "./MailingAddComponent.vue?vue&type=script&lang=js"
export * from "./MailingAddComponent.vue?vue&type=script&lang=js"

import "./MailingAddComponent.vue?vue&type=style&index=0&id=1ddac058&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddac058"]])

export default __exports__